import { useEffect, useState, ChangeEvent, ReactElement } from "react";
import { ITaskAttachment, ITask } from "../types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab, Tabs,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { cloneObject } from "../../../../system/utils";
import TabPanel from "../../../../components/tabPanel";
import TaskInfo from "./taskInfo";
import TaskControl from "./taskControl";
import { useSelector } from "react-redux";
import { IState } from "../../../../types";
import TaskAttach from "./taskAttach";
import { useFetch } from "../../../../system/useFetch";

const TitleLength = 10;
const DescriptionLength = 20;

interface IProps {
  isManager: boolean;
  task: ITask;
  onClose: () => void;
  onAccept: (task: ITask, attachments: ITaskAttachment[]) => void;
}


const TaskEditor = ({ task, onClose, onAccept, isManager }: IProps): ReactElement => {
  const [data, setData] = useState(cloneObject(task));
  const [tab, setTab] = useState(0);
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [attachments, setAttachments] = useState<ITaskAttachment[]>([]);
  const { loading, data: response } = useFetch<ITaskAttachment[]>(
    {
      module: "task",
      query: "getAttachments",
      payload: {
        taskID: task.taskID
      }
    });

  const disabledSave = data.title.length < TitleLength || data.description.length < DescriptionLength;

  useEffect(() => {
    if (response) {
      setAttachments(response);
    }
  },
  [response, task]);

  const onInternalAccept = () => {
    onAccept(data, attachments);
  };

  const handleTabChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Dialog open={true} maxWidth={"lg"} keepMounted={true}>
      <DialogTitle>{task.taskID ? "Edit Task" : "New Task"}</DialogTitle>

      <DialogContent dividers={true} style={{ width: 600 }} className="p-2">
        <Tabs
          value={tab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered={true}
          style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
          <Tab label="Info"/>
          <Tab label="Attachments"/>
          <Tab label="Control"/>
          {/*{isManager && <Tab label="Detail"/>}*/}
        </Tabs>

        <TabPanel value={tab} index={0}>
          <TaskInfo data={data} setData={setData} />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <TaskAttach attachments={attachments} setAttachments={setAttachments} loading={loading}/>
        </TabPanel>

        <TabPanel value={tab} index={2}>
          <TaskControl data={data} setData={setData} isManager={isManager}/>
        </TabPanel>

        {/*<TabPanel value={tab} index={3}>*/}

        {/*</TabPanel>*/}

      </DialogContent>
      <DialogActions>
        <Button onClick={onInternalAccept} variant="contained" color="primary" startIcon={<SaveIcon/>}
          disabled={disabledSave}>
          Save
        </Button>
        <Button onClick={onClose} variant="contained" color="secondary" startIcon={<CloseIcon/>}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TaskEditor;
